import { render } from "./SectionsListUpload.vue?vue&type=template&id=22821435&scoped=true"
import script from "./SectionsListUpload.vue?vue&type=script&lang=js"
export * from "./SectionsListUpload.vue?vue&type=script&lang=js"

import "./SectionsListUpload.vue?vue&type=style&index=0&id=22821435&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22821435"]])

export default __exports__